import { apiRequest } from '@common/api/utils';

const BASE_URL = '/referrals/achievements';

function fetchAchievements() {
  return apiRequest('GET', BASE_URL);
}

function fetchAchievementData(nudgeType) {
  const url = `${BASE_URL}/achievement-data`;
  return apiRequest('POST', url, { nudge_type: nudgeType });
}

function fetchLocale() {
  return apiRequest('GET', `${BASE_URL}/locale`);
}

export default {
  fetchLocale,
  fetchAchievements,
  fetchAchievementData,
};
